<template>
    <div>
        <pui-icon
            v-if="showCheckMark"
            :icon-color="color"
            icon-name="check"
        />
        {{ title }}
    </div>
</template>

<script lang="ts">
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ICellRendererParams } from 'ag-grid-community';

interface CheckmarkCell extends ICellRendererParams {
    color: string,
}

@Component({})
export default class CheckmarkCellComponent extends Vue {
    private params?: CheckmarkCell;

    private get title(): string {
        return this.params.value;
    }

    private get color(): string | undefined {
        return this.params?.color;
    }

    private get showCheckMark(): boolean {
        return this.title !== 'None';
    }
}
</script>

<style scoped lang="scss">
</style>
